import { FoodDrinksActivity, ItineraryActivity } from "../models/activity.model";
import { BaseActivityCard } from "./BaseActivityCard";
import { DocumentationList } from "@/components/ui/documentation-list";
import {
  ActivityAddress,
  ActivityDateRange,
  ActivityTimeRange,
  ActivityLink
} from "./ActivityFields";

interface FoodDrinksCardProps {
  activity: FoodDrinksActivity;
  onEdit: (activity: ItineraryActivity) => void;
  onDelete: (activity: ItineraryActivity) => void;
  onDuplicate?: (activity: ItineraryActivity) => void;
  onSaveToLibrary?: (activity: ItineraryActivity) => void;
  onExpand?: () => void;
  isReadOnly?: boolean;
  onDragStart?: (activity: ItineraryActivity) => void;
  onDropBefore?: (sourceActivityId: string, targetActivityId?: string) => void;
  onDragEnd?: () => void;
  isTraveler?: boolean;
  isAdmin?: boolean;
  unsaved?: boolean;
}

export const FoodDrinksCard = ({
  activity,
  onEdit,
  onDelete,
  onDuplicate,
  onSaveToLibrary,
  onExpand,
  isReadOnly = false,
  onDragStart,
  onDropBefore,
  onDragEnd,
  isTraveler = false,
  isAdmin = false,
  unsaved = false,
}: FoodDrinksCardProps) => {

  const renderAlwaysVisible = () => (
    <>
      <ActivityAddress address={activity.address} />
      <ActivityDateRange start_date={activity.start_date} end_date={activity.end_date} />
      <ActivityTimeRange start_time={activity.start_time} end_time={activity.end_time} />
      {/* NON ABBIAMO UN COSTO PER L'ATTIVITÀ DI CIBO E BEVANDE */}
    </>
  );

  const renderCollapsible = () => (
    <>

      {/* Documentation */}
      <DocumentationList documentation={activity.documentation || []} />

      {/* Link */}
      <ActivityLink link={activity.link} isAdmin={isAdmin} isTraveler={isTraveler} />
    </>
  );

  return (
    <BaseActivityCard
      activity={activity}
      onEdit={onEdit}
      onDelete={onDelete}
      onDuplicate={onDuplicate}
      onSaveToLibrary={onSaveToLibrary}
      onDragStart={onDragStart}
      onDropBefore={onDropBefore}
      onDragEnd={onDragEnd}
      onExpand={onExpand}
      isReadOnly={isReadOnly}
      isTraveler={isTraveler}
      isAdmin={isAdmin}
      unsaved={unsaved}
      media={activity.media}
    >
      {{
        alwaysVisible: renderAlwaysVisible(),
        collapsible: renderCollapsible()
      }}
    </BaseActivityCard>
  );
};
